import { useQuery } from '@tanstack/react-query';

import { fetchLADClaimFilesForEmail } from '../data-provider/lad-claim-files-for-email';

export interface UseGetLADClaimFilesForEmailParams {
  ClaimKey: number;
}

export const useGetLADClaimFilesForEmail = ({ ClaimKey }: UseGetLADClaimFilesForEmailParams) => {
  return useQuery({
    enabled: Boolean(ClaimKey),
    queryFn: () => fetchLADClaimFilesForEmail({ claimKey: Number(ClaimKey) }),
    queryKey: ['claims-loss-and-damage-files-for-email', ClaimKey],
  });
};
